import type { TAccountType, TUser } from '@/types/user'

const presentationCreationPaths = ['/creator/presentation', '/creator/wordgenie/presentation', '/wordgenie-pro/presentation']

export function canCreatePresentations(user?: TUser | null, accountType?: TAccountType | null): boolean {
  return (
    accountType?.presentations !== false ||
    user?.permissions?.presentations === 1 ||
    user?.permissions?.superuser === 1
  )
}

export function isPresentationCreationPath(path: string): boolean {
  return presentationCreationPaths.some((prefix) => path.startsWith(prefix))
}
